import React from 'react';
import { Container } from '../../../../components/Container';
import { SectionHeading } from '../../../../components/SectionHeading';
import { IllustrationAndText } from '../../../../components/IllustrationAndText/v2';
import money from '../../../../assets/icons/wellness-money.svg';
import receipt from '../../../../assets/icons/wellness-receipt.svg';
import stethoscope from '../../../../assets/icons/wellness-stethoscope.svg';
import { WELLNESS_REIMBURSEMENT_URL } from '../../../../constants';
import { Typography } from '../../../../wag-react/components/Typography';
import { Link } from '../../../../wag-react/core-components/link';
import { Flex } from '../../../../wag-react/next-components/Flex';
import { Divider } from '../../../../wag-react/core-components/divider';
const items = [{
  title: 'Visit your vet',
  description: 'Visit your vet for wellness treatment, or to pick up their flea, tick, and heartworm meds.',
  illustration: stethoscope,
  illustrationAlt: 'wellness stethoscope'
}, {
  title: 'Request a reimbursement',
  description: <Typography>
        {'Fill out Wag!\'s '}
        <Link color="wagGreen" href={WELLNESS_REIMBURSEMENT_URL} target="_blank">
          reimbursement form
        </Link>
        {' '}
        with your contact and vet visit information,
      </Typography>,
  illustration: receipt,
  illustrationAlt: 'wellness receipt'
}, {
  title: 'Get reimbursed',
  description: 'Get your money back within 24 hours (during business days). NOBODY pays reimbursements faster than Wag!.',
  illustration: money,
  illustrationAlt: 'wellness reimbursement'
}];
export const WellnessHowItWorksSection = () => <Container pb={['60px', '40px']} pt={['48px', '40px']} data-sentry-element="Container" data-sentry-component="WellnessHowItWorksSection" data-sentry-source-file="index.tsx">
    <SectionHeading data-sentry-element="SectionHeading" data-sentry-source-file="index.tsx">
      How it works
    </SectionHeading>

    <Flex alignItems={['center', null, 'flex-start']} justifyContent={['flex-start', null, 'center']} flexDirection={['column', null, 'row']} mt={['16px', '32px', '40px']} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
      {items.map(({
      description,
      illustration,
      illustrationAlt,
      title
    }, index) => {
      const isFirstItem = index === 0;
      const key = `IllustrationAndText-${index}`;
      return <IllustrationAndText key={key} descriptionText={description} illustrationSrc={illustration} illustrationAlt={illustrationAlt} illustrationProps={{
        height: '50px'
      }} ml={isFirstItem ? undefined : [0, 0, '16px']} mt={isFirstItem ? undefined : ['40px', '32px', 0]} titleText={title} />;
    })}
    </Flex>

    <Divider bg="none" border="unset" borderTop="2px dashed #D1D1D1" mt={5} data-sentry-element="Divider" data-sentry-source-file="index.tsx" />
  </Container>;